import React from 'react';

import { IconTypes } from '@eika/icon';
import { AttentionLabel } from '@eika/label';
import { Link } from '@eika/link';

import { InfoHeaderItem } from './InfoItem';
import TransactionCategoryLabel from './TransactionCategoryLabel';
import fallbackDictionary from './fallbackDictionary';
import { CardInfo, SiteCoreDictionary } from './types';

import './TransactionDetailsKb.scss';

interface TransactionDetailsProps {
    amount: string;
    cardInfo?: CardInfo;
    downloadHref?: string;
    sitecoreDictionary?: SiteCoreDictionary;
    label: string;
}

const TransactionDetailsKb = ({
    amount,
    cardInfo,
    sitecoreDictionary,
    downloadHref,
    label,
    children,
}: React.PropsWithChildren<TransactionDetailsProps>) => {
    const dictionary: SiteCoreDictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    const { transactionsAmount, downloadAsPdfText } = dictionary;

    return (
        <div className="kbj-transaction-detail">
            <section className="kbj-transaction-detail__header">
                {cardInfo?.isBlocked && (
                    <div className="kbj-transaction-detail__header">
                        <AttentionLabel text={cardInfo.status} icon={IconTypes.PIN_KODE_24} />
                    </div>
                )}
                {(cardInfo?.isCredit || label) && <TransactionCategoryLabel label={label} />}
                <InfoHeaderItem id="amount" name={amount} label={transactionsAmount} />
            </section>

            <div className="kbj-transaction-detail__list">{children}</div>
            {downloadHref && (
                <Link href={downloadHref} icon={IconTypes.NEDLASTING_24}>
                    {downloadAsPdfText}
                </Link>
            )}
        </div>
    );
};

export default TransactionDetailsKb;
